import { AnyAction } from 'redux';
import opApiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { batch } from 'react-redux';
import apiTypes from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import { Store } from 'store/index';
import { ThunkDispatch } from 'redux-thunk';
import { SetPricesActionPayload } from 'store/price/reducer/setPricesReducer';
import getCurrencyId from 'store/price/selector/getCurrencyId';
import getPriceFormat from 'store/price/selector/getPriceFormat';
import { setPriceFormatAction, setCurrencyIdAction, setPricesAction } from 'store/price/slice';
import getPricesToFetch from '../selector/getPricesToFetch';
import removeFromPricesToFetchOperation from './removeFromPricesToFetchOperation';

const fetchBatchPricesOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    let store = getState();
    const pricesToFetch = getPricesToFetch(store);
    if (!pricesToFetch) {
      return;
    }

    const priceFetchPromises: Promise<any>[] = [];
    const categoryProducts: any[] = [];

    Object.keys(pricesToFetch).forEach((categoryId) => {
      const { productIds } = pricesToFetch[categoryId];
      categoryProducts.push({
        categoryId,
        productIds,
      });
    });

    priceFetchPromises.push(
      opApiRequest(
        endpoints.productV2PriceList,
        {
          categoryProducts,
        },
        HttpMethods.POST,
        'data',
      ).then((response) => {
        if (!response) {
          // eslint-disable-next-line no-console
          console.error('Cannot fetch prices');
          return;
        }
        // get updated store
        store = getState();
        batch(() => {
          if (!getPriceFormat(store)) {
            dispatch(
              setPriceFormatAction(
                (response as apiTypes.AppBundle.Api.Response.Product.V2.ProductPriceListV2Response).priceFormat,
              ),
            );
          }

          if (!getCurrencyId(store)) {
            dispatch(
              setCurrencyIdAction(
                (response as apiTypes.AppBundle.Api.Response.Product.V2.ProductPriceListV2Response).currencyId,
              ),
            );
          }

          const res = response as apiTypes.AppBundle.Api.Response.Product.V2.ProductPriceListV2Response;

          res.prices.forEach((val) => {
            const payload: SetPricesActionPayload = {
              categoryId: Number(val.categoryId),
              prices: val.products as apiTypes.AppBundle.Api.Entity.Product.V1.IProductPriceListProduct[],
            };

            dispatch(setPricesAction(payload));
            dispatch(
              removeFromPricesToFetchOperation(
                Number(val.categoryId),
                val.products ? val.products.map((p) => p.productId) : [],
              ),
            );
          });
        });
      }),
    );

    await Promise.all(priceFetchPromises);
  };

export default fetchBatchPricesOperation;
